module.exports = __webpack_public_path__ + "static/media/affiliate-program.13680247.png";